/**
 * src/components/Characters/index.jsx
 * create and display characters
 *
 * created by Lynchee on 7/16/23
 */

// Characters
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import GroupsIcon from '@mui/icons-material/Groups';
import './style.css';
import { useEffect } from 'react';

const Characters = ({
  isMobile,
  characterGroups,
  selectedCharacter,
  setSelectedCharacter,
  isPlaying,
  characterConfirmed,
  onCharacterSelection,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [openLibraryDialog, setOpenLibraryDialog] = useState(false);
  const [avatarWidth, setAvatarWidth] = useState(0);
  const [avatarHeight, setAvatarHeight] = useState(0);

  const handleCharacterSelection = character => {
    setSelectedCharacter(character);
    onCharacterSelection(character);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleOpenLibraryDialog = () => {
    setOpenLibraryDialog(true);
  };

  const handleCloseLibraryDialog = () => {
    setOpenLibraryDialog(false);
  };

  useEffect(() => {
    const screenWidth = window.screen.width;
    const size = isMobile ? screenWidth * 0.3 : screenWidth * 0.1;
    setAvatarWidth(size);
    setAvatarHeight(size);
  }, []);

  return (
    <Grid
      container
      spacing={2}
      sx={{ marginBottom: 5 }}
      className='main-container'
    >
      {characterGroups.map(
        (character, index) =>
          ((!characterConfirmed && character.source === 'default') ||
            (selectedCharacter &&
              character.character_id === selectedCharacter.character_id)) && (
            <Grid item xs={isMobile ? 12 : 6} textAlign={'center'} key={index}>
              <Button
                // variant='outlined'
                onClick={() => handleCharacterSelection(character)}
                // sx={{
                //   width: '100%',
                //   backgroundColor:
                //     selectedCharacter &&
                //     character.character_id === selectedCharacter.character_id
                //       ? '#35394A'
                //       : '#1B2134',
                //   borderColor:
                //     selectedCharacter &&
                //     character.character_id === selectedCharacter.character_id
                //       ? '#A7BFFF'
                //       : '#1B2134',
                //   '&:hover': {
                //     backgroundColor: '#35394A',
                //     borderColor: '#617CC2',
                //   },
                //   display: 'flex',
                //   justifyContent: 'left',
                //   textTransform: 'none',
                // }}
                className='character-item'
              >
                <Avatar
                  alt={character.name}
                  src={character.image_url}
                  sx={{ width: avatarWidth, height: avatarHeight }}
                  className='character-avatar'
                />
                <Typography
                  variant='body1'
                  sx={{
                    fontSize: isMobile ? '12px' : '1.2vw',
                    // color: 'white',
                    fontFamily: 'Prompt, sans-serif',
                  }}
                  color={'#000000'}
                  align='center'
                >
                  {character.name}
                </Typography>
              </Button>
            </Grid>
          )
      )}

      {/* <Grid item xs={isMobile ? 12 : 6}>
        <Button
          variant='outlined'
          onClick={handleOpenDialog}
          sx={{
            width: '100%',
            backgroundColor: '#1B2134',
            borderColor: '#1B2134',
            '&:hover': {
              backgroundColor: '#35394A',
              borderColor: '#617CC2',
            },
            display: 'flex',
            justifyContent: 'left',
            textTransform: 'none',
          }}
        >
          <Avatar sx={{ backgroundColor: 'transparent' }}>
            <GroupsIcon sx={{ color: 'white' }} />
          </Avatar>

          <Typography
            variant='body1'
            sx={{
              color: 'white',
              fontFamily: 'Prompt, sans-serif',
            }}
          >
            Select from community
          </Typography>
        </Button>
      </Grid>

      <Grid item xs={isMobile ? 12 : 6}>
        <Button
          variant='outlined'
          onClick={handleOpenLibraryDialog}
          sx={{
            width: '100%',
            backgroundColor: '#1B2134',
            borderColor: '#1B2134',
            '&:hover': {
              backgroundColor: '#35394A',
              borderColor: '#617CC2',
            },
            display: 'flex',
            justifyContent: 'left',
            textTransform: 'none',
          }}
        >
          <Avatar sx={{ backgroundColor: 'transparent' }}>
            <GroupsIcon sx={{ color: 'white' }} />
          </Avatar>

          <Typography
            variant='body1'
            sx={{
              color: 'white',
              fontFamily: 'Prompt, sans-serif',
            }}
          >
            Select from your library
          </Typography>
        </Button>
      </Grid> */}

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby='dialog-title'
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: '#050E2E',
            color: 'white',
            borderColor: '#3E496D',
            borderStyle: 'solid',
          },
        }}
      >
        <DialogTitle id='dialog-title'>
          {' '}
          Select partner from RealChar community{' '}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {characterGroups.map((character, index) => {
              return character.source === 'community' &&
                !character.is_author ? (
                <Grid item xs={isMobile ? 12 : 6} key={index}>
                  <Button
                    variant='outlined'
                    onClick={() => handleCharacterSelection(character)}
                    sx={{
                      width: '100%',
                      backgroundColor:
                        selectedCharacter &&
                        character.character_id ===
                          selectedCharacter.character_id
                          ? '#35394A'
                          : '#1B2134',
                      borderColor:
                        selectedCharacter &&
                        character.character_id ===
                          selectedCharacter.character_id
                          ? '#A7BFFF'
                          : '#1B2134',
                      '&:hover': {
                        backgroundColor: '#373E58',
                        borderColor: '#A7BFFF',
                      },
                      display: 'flex',
                      justifyContent: 'left',
                      textTransform: 'none',
                    }}
                  >
                    <Avatar
                      alt={character.name}
                      src={character.image_url}
                      sx={{ marginRight: 1 }}
                    />
                    <div style={{ display: 'block', textAlign: 'left' }}>
                      <Typography
                        variant='body1'
                        sx={{
                          color: 'white',
                          fontFamily: 'Prompt, sans-serif',
                        }}
                      >
                        {character.name}
                      </Typography>
                      <Typography
                        variant='body1'
                        sx={{
                          color: '#BEC5D9',
                          fontFamily: 'Prompt, sans-serif',
                          fontStyle: 'italic',
                        }}
                      >
                        @{character.author_name}
                      </Typography>
                    </div>
                  </Button>
                </Grid>
              ) : null;
            })}
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'center',
            marginBottom: 2,
            marginLeft: 2,
            marginRight: 2,
          }}
        >
          <Button
            fullWidth
            variant='contained'
            onClick={handleCloseDialog}
            sx={{ color: 'white', textTransform: 'none' }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openLibraryDialog}
        onClose={handleCloseLibraryDialog}
        aria-labelledby='dialog-title'
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: '#050E2E',
            color: 'white',
            borderColor: '#3E496D',
            borderStyle: 'solid',
          },
        }}
      >
        <DialogTitle id='dialog-title'>
          {' '}
          Select partner from your library{' '}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {characterGroups.map((character, index) => {
              return character.source === 'community' && character.is_author ? (
                <Grid item xs={isMobile ? 12 : 6} key={index}>
                  <Button
                    variant='outlined'
                    onClick={() => handleCharacterSelection(character)}
                    sx={{
                      width: '100%',
                      backgroundColor:
                        selectedCharacter &&
                        character.character_id ===
                          selectedCharacter.character_id
                          ? '#35394A'
                          : '#1B2134',
                      borderColor:
                        selectedCharacter &&
                        character.character_id ===
                          selectedCharacter.character_id
                          ? '#A7BFFF'
                          : '#1B2134',
                      '&:hover': {
                        backgroundColor: '#373E58',
                        borderColor: '#A7BFFF',
                      },
                      display: 'flex',
                      justifyContent: 'left',
                      textTransform: 'none',
                    }}
                  >
                    <Avatar
                      alt={character.name}
                      src={character.image_url}
                      sx={{ marginRight: 1 }}
                    />
                    <div style={{ display: 'block', textAlign: 'left' }}>
                      <Typography
                        variant='body1'
                        sx={{
                          color: 'white',
                          fontFamily: 'Prompt, sans-serif',
                        }}
                      >
                        {character.name}
                      </Typography>
                      <Typography
                        variant='body1'
                        sx={{
                          color: '#BEC5D9',
                          fontFamily: 'Prompt, sans-serif',
                          fontStyle: 'italic',
                        }}
                      >
                        @{character.author_name}
                      </Typography>
                    </div>
                  </Button>
                </Grid>
              ) : null;
            })}
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'center',
            marginBottom: 2,
            marginLeft: 2,
            marginRight: 2,
          }}
        >
          <Button
            fullWidth
            variant='contained'
            onClick={handleCloseLibraryDialog}
            sx={{ color: 'white', textTransform: 'none' }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default Characters;
